<template>
  <div>
    <v-btn
      dark 
      color="primary"
      class="mr-2"
      @click="abrirDialog()"
    >
      <v-icon left>mdi-import</v-icon>
      Importar
    </v-btn>

    <SysDialog
      v-model="dialog"
      content-class="bra-20"
      titulo="Importação de lista"
      @click:primary="aplicarListaImportada()"
      @click:hidden-dialog="fecharDialog()"
    >
      <AlertError :errors="errors" />

      <InformativoFormatoArquivo class="mb-2" />

      <SysFileInput
        v-model="arquivo_importacao"
        titulo_label="Arquivo de Importação"
        outlined
        :error-messages="ERROR_ARQUIVO_IMPORTACAO"
        @keydown.enter="aplicarListaImportada"
      />
    </SysDialog>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { aplicarListaImportada } from "@/api/drp/blacklist.js";
import InformativoFormatoArquivo from './InformativoFormatoArquivo.vue';
import AlertError from '@/components/utils/Alerts/AlertError.vue';
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import SysFileInput from '@/components/utils/SysFileInput.vue';

export default {
  components: {
    SysDialog,
    SysFileInput,
    InformativoFormatoArquivo,
    AlertError
},
  data() {
    return {
      dialog: false,
      arquivo_importacao: null,
      errors: []
    }
  },
  computed: {
    ERROR_ARQUIVO_IMPORTACAO() {
      const errors = [];
      if (!this.$v.arquivo_importacao.$dirty) return errors;
      !this.$v.arquivo_importacao.required && errors.push("Campo obrigatório.");
      return errors;
    },
  },
  methods: {
    abrirDialog() {
      this.dialog = true;
    },
    fecharDialog() {
      this.$v.$reset();
      this.arquivo_importacao = null;
      this.errors = [];
      this.dialog = false;
    },
    aplicarListaImportada(e) {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      this.$store.dispatch(
        "loading/addRequisicao",
        aplicarListaImportada(this.arquivo_importacao)
          .then((message) => {
            if (message) {
              this.errors = message;
            } else {
              this.fecharDialog();
              this.$emit('atualizar-listas');
            }
          })
      );
    }
  },
  validations: {
    arquivo_importacao: { required }
  }
}
</script>
